var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from '../styled-components';
var Form = styled.form(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  opacity: ", ";\n  pointer-events: ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  opacity: ", ";\n  pointer-events: ", ";\n"])), function (p) { return (p.disabled ? 0.5 : 1); }, function (p) { return (p.disabled ? 'none' : 'all'); });
export default Form;
var templateObject_1;
